<template>
  <div>
    <expense-detail :expense_id="expense_id" />
    <vs-table :data="data" minHeight="60vh">
      <template slot="thead">
        <vs-th class="qb-sticky" :style="{ width: '40vw' }">
          {{ $t('vendor') }}
        </vs-th>
        <vs-th class="qb-sticky" :style="{ width: '40vw' }">
          {{ `${$t('folio')} | ${$t('date')} | ${$t('year')} - ${$t('week')} | ${$t('pay_date')}` }}
        </vs-th>
        <vs-th class="qb-sticky" :style="{ width: '20vw' }">
          {{ $t('category') }}
        </vs-th>
        <vs-th class="qb-sticky" :style="{ width: '20vw' }">
          {{ $t('currency') }}
        </vs-th>
        <vs-th class="qb-sticky" :style="{ width: '20vw' }">
          {{ $t('status') }}
        </vs-th>
        <vs-th class="qb-sticky" :style="{ width: '5vw' }"> </vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td class="text-left">
            {{ data[indextr].VendorName }}
          </vs-td>
          <vs-td class="text-left">
            {{
              `${data[indextr].Folio} | ${formatDate(
                data[indextr].ReceivedDate
              )} | ${data[indextr].Year} - ${data[indextr].Week} | ${formatDate(
                data[indextr].PayDate
              )}`
            }}
          </vs-td>
          <vs-td class="text-left">
            {{ data[indextr].CategoryName }}
          </vs-td>
          <vs-td class="text-left">
            {{
              currency == 'USD'
                ? Number(data[indextr].BI_TotalUSD).toLocaleString('en-US') +
                  ' ' +
                  currency
                : Number(data[indextr].BI_TotalMXP).toLocaleString('en-US') +
                  ' ' +
                  currency
            }}
          </vs-td>
          <vs-td class="text-left">
            <vs-button
              :color="data[indextr].status_color || 'grey'"
              text-color="white"
              type="filled"
              size="small"
              disabled
            >
              {{ data[indextr].StatusName }}
            </vs-button>
          </vs-td>
          <vs-td class="text-left">
            <action-icon
              icon="ArrowRightCircleIcon"
              :tooltip="$t('details')"
              @click="expenseDetail(data[indextr].ExpenseId)"
            />
          </vs-td>
        </vs-tr>
        <vs-tr>
          <vs-td colspan="100%">
            <div
              v-if="data.length"
              v-observe-visibility="infiniteHandler"
            ></div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import ExpenseDetail from '@/views/apps/accounting/components/ExpenseDetail.vue'
import ActionIcon from '@/views/qb-components/actions/ActionIcon.vue'
export default {

  components: {
    ExpenseDetail,
    ActionIcon,
  },
  data: () => ({
    expense_id: ''
  }),
  methods: {
    infiniteHandler(isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    },
    expenseDetail(expense_id) {
      this.$store.dispatch('setFilter', {});
      this.expense_id = expense_id
      this.$store.dispatch('toggleSidebar', 'expense-detail')
    },
  },
  props: {
    currency: {
      type: String,
      default: 'USD'
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style>
.qb-sticky {
  background: white;
  position: sticky;
  top: 0;
}
</style>
